{
  "mar": {
    "title": "投薬記録",
    "loading": "投薬記録を読み込み中...",
    "emptyState": "この患者に有効な投薬指示はありません",
    "loadError": "薬剤の読み込みに失敗しました",
    "retry": "再試行",
    "previousDay": "前日",
    "nextDay": "翌日",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "勤務帯",
    "dayShiftHeader": "日勤（07:00 - 19:00）",
    "nightShiftHeader": "夜勤（19:00 - 07:00）",
    "newOrder": "新規投薬指示",
    "printMar": "投薬記録を印刷",
    "prnSection": "頓用（PRN）薬剤",
    "filter": {
      "timeWindow": "時間帯",
      "category": "カテゴリー",
      "status": "ステータス",
      "scheduledOnly": "予定投薬のみ"
    },
    "adminStatus": {
      "scheduled": "予定",
      "dueNow": "投与時刻",
      "overdue": "遅延",
      "administered": "投与済み",
      "held": "保留",
      "refused": "拒否",
      "missed": "未投与"
    },
    "columns": {
      "medication": "薬品",
      "drug": "薬品",
      "doseRoute": "用量 / 投与経路",
      "schedule": "スケジュール",
      "scheduledTime": "予定時刻",
      "givenTime": "投与時刻",
      "givenBy": "投与者",
      "status": "ステータス"
    },
    "actions": {
      "administer": "投薬",
      "hold": "保留",
      "refuse": "拒否",
      "skip": "スキップ",
      "missed": "未投与として記録",
      "edit": "投薬記録を編集",
      "viewHistory": "履歴を表示",
      "givePrn": "PRN 投薬"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "ハイアラート",
      "indication": "適応：{{indication}}",
      "lastGiven": "前回投与：{{time}}",
      "lastGivenBy": "前回投与：{{time}}（{{user}}）"
    },
    "orderBadge": {
      "active": "実施中",
      "onHold": "保留中",
      "discontinued": "中止"
    },
    "legend": "凡例：",
    "summary": {
      "medsGivenToday": "本日の投薬：",
      "ofTotal": "{{given}} / {{total}}",
      "overdueCount_one": "遅延 {{count}} 件",
      "overdueCount_other": "遅延 {{count}} 件",
      "nextDue": "次回投与：",
      "nextDueAt": "{{medName}}（{{time}}）"
    },
    "tooltip": {
      "given": "（{{time}} に投与）",
      "pending": "記録中… サーバー未確定"
    },
    "doseModal": {
      "title": "投薬",
      "doseGiven": "実投与量",
      "siteOfAdministration": "投与部位",
      "comments": "コメント",
      "vitalsCheck": "投薬前バイタル確認",
      "doubleCheck": "ダブルチェック",
      "verifier": "確認者",
      "confirm": "投薬を確定"
    },
    "administerDialog": {
      "doseLabel": "用量",
      "routeLabel": "投与経路",
      "siteLabel": "投与部位（該当する場合）",
      "site": {
        "notApplicable": "該当なし",
        "leftArm": "左上腕",
        "rightArm": "右上腕",
        "leftDeltoid": "左三角筋",
        "rightDeltoid": "右三角筋",
        "leftGluteal": "左臀部",
        "rightGluteal": "右臀部",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "abdomen": "腹部"
      },
      "timeAdministered": "投与日時",
      "administeredDateAria": "投与日",
      "administeredTimeAria": "投与時刻",
      "notesLabel": "備考",
      "notesPlaceholder": "任意の備考..."
    },
    "prnWarning": {
      "title": "PRN 投与間隔の警告",
      "lastDoseHoursAgo": "前回の投与から {{hours}} 時間経過しています。",
      "minimumInterval": "最短間隔は {{hours}} 時間です。",
      "lastAdministered": "前回投与：{{time}}",
      "justificationLabel": "早期投与の理由",
      "justificationRequired": "*",
      "justificationPlaceholder": "最短間隔より前に投与する臨床的理由を入力...",
      "cancel": "キャンセル",
      "overrideContinue": "上書きして続行"
    },
    "toast": {
      "administered": "投薬を記録しました",
      "administerError": "投薬の記録に失敗しました",
      "administerNotImplemented": "MAR 投薬記録機能はまだ利用できません",
      "held": "投薬を保留しました",
      "refused": "患者の拒否を記録しました",
      "skipped": "投薬をスキップしました",
      "orderNotActive": "この指示は既に無効（中止・キャンセル・完了）のため、投与を記録できません。"
    },
    "holdRefuseDialog": {
      "holdTitle": "投薬を保留",
      "refuseTitle": "投薬を拒否",
      "skipTitle": "投薬をスキップ",
      "scheduledLabel": "予定：{{time}}",
      "holdReasonLabel": "保留理由",
      "refusalNotesLabel": "拒否の記録",
      "skipReasonLabel": "スキップ理由",
      "holdReasonPlaceholder": "保留の理由を入力...",
      "refusalPlaceholder": "患者の拒否を記録...",
      "skipPlaceholder": "スキップの理由を入力...",
      "cancel": "キャンセル",
      "confirm": "確定"
    },
    "contextMenu": {
      "hold": "保留",
      "refuse": "拒否",
      "skip": "スキップ"
    },
    "holdReason": {
      "label": "保留理由",
      "options": {
        "patientNpo": "患者 NPO（絶飲食）",
        "vitalsOutOfRange": "バイタル異常",
        "patientRefused": "患者の拒否",
        "providerOrder": "医師の保留指示",
        "other": "その他"
      }
    },
    "give": {
      "title": "投与 · {{medication}} {{dose}}",
      "scheduledLabel": "予定 {{time}}",
      "patientLabel": "患者",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "患者ID：{{id}}",
      "medicationLabel": "薬品",
      "scanPatientPlaceholder": "リストバンドをスキャン",
      "scanPatientAria": "患者リストバンドをスキャン",
      "scanMedicationPlaceholder": "薬品パッケージのバーコードをスキャン",
      "scanMedicationAria": "薬品パッケージをスキャン",
      "patientMismatch": "このリストバンドはこの患者のものではありません。投与しないでください。",
      "medicationMismatch": "このパッケージは指示された薬品ではありません。投与しないでください。",
      "notScannable": "スキャン照合できません — この指示にはバーコードが登録されていません",
      "overrideReason": "スキャンせずに投与する理由",
      "overrideReasonPlaceholder": "例：リストバンド破損、バーコードのない調製薬",
      "pharmacyOverride": "薬剤部がこのハイアラート薬品を監査していません",
      "pharmacyOverridePlaceholder": "この投与が薬剤部の監査を待てない理由は？",
      "timeLabel": "時刻",
      "detailsEdit": "編集",
      "detailsDone": "完了",
      "confirmLabel": "指示と手元の薬品が一致していることを確認しました",
      "cancel": "キャンセル",
      "submit": "投与",
      "witness": {
        "banner": "ハイアラート — 第二看護師による立会確認が必要",
        "usernameLabel": "第二看護師のユーザー名",
        "passwordLabel": "パスワード",
        "verify": "確認",
        "verifying": "確認中…",
        "verified": "第二看護師が立会確認しました",
        "rejected": "認証情報が確認できません。",
        "overrideLabel": "立会不可の場合：第二看護師の確認なしで投与する理由",
        "overridePlaceholder": "この投与が独立したダブルチェックを待てない理由は？"
      },
      "refusal": {
        "wrongPatient": "患者違い — スキャンしたリストバンドがこの指示と一致しません。投与しないでください。",
        "wrongMedication": "薬品違い — スキャンしたパッケージが指示された薬品と一致しません。投与しないでください。",
        "scanRequired": "リストバンドと薬品をスキャンするか、スキャンしない理由を入力してください。",
        "pharmacyVerificationRequired": "薬剤部がこの指示を監査していません。監査を待つか、待てない理由を記録してください。",
        "doubleCheckRequired": "この指示は第二看護師のダブルチェックが未実施です。立会確認を受けるか、待てない理由を記録してください。",
        "doubleCheckSelf": "自分の投与を自分で立会確認することはできません。第二看護師による確認が必要です。"
      },
      "dispense": {
        "handedOver": "{{quantity}} を {{time}} に受け渡し",
        "label": "薬剤部払い出し",
        "none": "この指示の払い出し記録はありません",
        "pending": "払い出しは記録済み、未受け渡し",
        "prepared": "{{quantity}} を {{time}} に調剤",
        "unavailable": "払い出し状況を確認できません——記録に到達できませんでした"
      }
    }
  },
  "status": {
    "active": "実施中",
    "held": "保留",
    "discontinued": "中止",
    "completed": "完了",
    "refused": "拒否",
    "missed": "未投与",
    "given": "投与済み"
  },
  "route": {
    "po": "経口",
    "iv": "静脈内注射",
    "im": "筋肉内注射",
    "sc": "皮下注射",
    "in": "経鼻",
    "pr": "経直腸",
    "sl": "舌下",
    "top": "外用",
    "neb": "ネブライザー吸入",
    "pv": "経膣",
    "ng": "経鼻胃管",
    "ophthalmic": "点眼",
    "transdermal": "経皮"
  },
  "frequency": {
    "bid": "1日2回",
    "tid": "1日3回",
    "qid": "1日4回",
    "qd": "1日1回",
    "qhs": "就寝前",
    "prn": "頓用（PRN）",
    "stat": "直ちに（STAT）",
    "continuous": "持続投与"
  },
  "formulary": {
    "title": "薬剤フォーミュラリー",
    "searchPlaceholder": "薬品名・一般名・コードで検索...",
    "clearSearch": "検索をクリア",
    "category": {
      "all": "すべて",
      "analgesic": "鎮痛薬",
      "antibiotic": "抗菌薬",
      "antifungal": "抗真菌薬",
      "antiviral": "抗ウイルス薬",
      "cardiac": "循環器系",
      "endocrine": "内分泌系",
      "gi": "消化器系",
      "neurological": "神経系",
      "psychiatric": "精神科",
      "respiratory": "呼吸器系",
      "other": "その他"
    },
    "columns": {
      "medication": "薬剤",
      "genericName": "一般名",
      "form": "剤形",
      "strength": "規格",
      "route": "投与経路",
      "status": "状態",
      "schedule": "規制区分"
    },
    "highAlertBadge": "高警戒薬",
    "highAlertTag": "高警戒",
    "status": {
      "preferred": "推奨",
      "restricted": "制限あり",
      "nonFormulary": "採用外"
    },
    "loading": "フォーミュラリーを読み込み中...",
    "loadError": "フォーミュラリーを読み込めませんでした",
    "empty": "該当する薬剤が見つかりません。",
    "pagination": {
      "showing": "{{from}}〜{{to}} 件目（全 {{total}} 件）",
      "page": "{{page}} / {{totalPages}} ページ",
      "previous": "前のページ",
      "next": "次のページ"
    },
    "details": {
      "close": "詳細を閉じる",
      "genericName": "一般名",
      "category": "カテゴリ",
      "formStrength": "剤形 / 規格",
      "route": "投与経路",
      "formularyStatus": "フォーミュラリー状態",
      "deaSchedule": "DEA 規制区分",
      "indications": "適応",
      "contraindications": "禁忌",
      "interactions": "相互作用",
      "sideEffects": "副作用",
      "dosageGuidelines": "用法用量",
      "specialPopulations": "特殊集団",
      "storage": "保管方法"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "薬剤師確認キュー",
    "subtitle": "保留中の処方を確認・承認します",
    "pendingCount": "保留 {{count}} 件",
    "refresh": "更新",
    "searchPlaceholder": "薬剤名・患者名・MRN で検索...",
    "priority": {
      "all": "すべての優先度",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "通常",
      "scheduled": "予定"
    },
    "loadError": "処方キューを読み込めませんでした",
    "retry": "再試行",
    "empty": {
      "title": "対応完了",
      "description": "確認待ちの処方はありません。"
    },
    "columns": {
      "patient": "患者",
      "medication": "薬剤",
      "doseRouteFreq": "用量 / 経路 / 頻度",
      "priority": "優先度",
      "orderingProvider": "オーダー医師",
      "ordered": "オーダー日時",
      "actions": "操作"
    },
    "row": {
      "unknown": "不明",
      "mrnLabel": "MRN：{{mrn}}",
      "mrnUnknown": "---",
      "controlled": "規制薬 {{schedule}}",
      "providerFallback": "医師 #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "承認",
      "verifyTooltip": "この処方を承認する",
      "reject": "差戻",
      "rejectTooltip": "差戻して中止",
      "confirmReject": "確定",
      "cancelReject": "キャンセル",
      "rejectReasonPlaceholder": "差戻理由..."
    },
    "toast": {
      "verifySuccess": "処方 #{{id}} を承認しました",
      "verifyError": "処方の承認に失敗しました",
      "rejectSuccess": "処方 #{{id}} を差戻し中止しました",
      "rejectError": "処方の差戻に失敗しました",
      "rejectReasonRequired": "差戻理由を入力してください",
      "notIndependent": "処方者は自分の処方を監査できません。",
      "overrideSuccess": "オーダー {{id}} を薬剤師確認なしで有効化しました",
      "overrideError": "オーバーライドを記録できませんでした",
      "overrideReasonRequired": "オーバーライドには理由コードと理由の両方が必要です"
    },
    "verifyDialog": {
      "title": "処方の監査",
      "instruction": "完了した確認項目にチェックしてください。4項目すべてが必須です — 部分的な確認は監査になりません。",
      "checks": {
        "allergy": "患者のアレルギー歴と照合しました",
        "interaction": "薬物相互作用を確認しました",
        "duplicateTherapy": "重複投薬を確認しました",
        "doseRange": "この患者の用量を確認しました"
      },
      "cancel": "キャンセル",
      "confirm": "監査する"
    },
    "override": {
      "action": "オーバーライド",
      "confirm": "オーバーライドを記録",
      "cancel": "キャンセル",
      "tooltip": "薬剤師の確認なしで続行します。理由を記録しますが、高警戒薬の薬剤部確認は満たしません。",
      "codeLabel": "オーバーライド理由コード",
      "codePlaceholder": "理由を選択…",
      "justificationLabel": "オーバーライドの理由",
      "justificationPlaceholder": "薬剤部の確認なしで続行する理由は？",
      "code": {
        "pharmacyClosed": "薬剤部閉室",
        "urgentClinicalNeed": "緊急の臨床的必要",
        "pharmacyUnreachable": "薬剤部に連絡不可"
      }
    },
    "clarify": {
      "action": "疑義照会",
      "tooltip": "薬剤部の入力内容が処方と異なります。解消するまで投与できません。",
      "heading": "薬剤部の入力が処方と異なります",
      "holding": "（オーダーを保留）",
      "upheld": "原処方どおり",
      "upheldTooltip": "原処方が正しいため、記載どおり調剤します。",
      "amended": "修正しました",
      "amendedTooltip": "オーダーを変更したことを記録します。",
      "adopt": "薬剤部の内容を採用",
      "adoptTooltip": "連携業務協定または薬事委員会の方針に基づき、入力内容を受け入れます。",
      "close": "閉じる",
      "toast": {
        "resolved": "疑義照会を解消しました。オーダーは確認待ちに戻ります",
        "error": "疑義照会を解消できませんでした"
      }
    }
  },
  "reconciliation": {
    "title": "薬剤鑑別",
    "subtitle": "{{patient}} | {{mrn}} | 受診 #{{encounter}}",
    "complete": "鑑別を完了",
    "loading": "薬剤を読み込み中...",
    "column": {
      "home": "持参薬",
      "inpatient": "入院処方",
      "discharge": "退院処方"
    },
    "emptyHome": "持参薬が見つかりません。",
    "emptyInpatient": "入院処方が見つかりません。",
    "emptyDischarge": "退院処方はまだありません。他の列で継続または修正を選択してください。",
    "changedFromHome": "持参薬から変更あり",
    "action": {
      "continue": "継続",
      "modify": "変更",
      "discontinue": "中止",
      "discontinueShort": "D/C",
      "newOrder": "新規"
    },
    "addToDischarge": "退院処方に追加",
    "remove": "削除",
    "modifyForm": {
      "title": "薬剤を変更",
      "dose": "用量",
      "route": "投与経路",
      "frequency": "投与頻度",
      "dosePlaceholder": "例：500mg",
      "routePlaceholder": "例：PO",
      "frequencyPlaceholder": "例：BID",
      "cancel": "キャンセル",
      "save": "保存"
    },
    "back": "戻る",
    "toast": {
      "completed": "薬剤鑑別を完了しました",
      "completeError": "鑑別の完了に失敗しました",
      "atLeastOne": "完了する前に少なくとも1件の薬剤を鑑別してください"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "投与量計算ツール",
      "weightLabel": "患者体重 (kg) *",
      "heightLabel": "身長 (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "例: 70",
      "heightPlaceholder": "例: 170",
      "gfrPlaceholder": "任意",
      "bsaLabel": "算出体表面積 (Mosteller):",
      "calculate": "投与量を計算",
      "error": "投与量を計算できませんでした。この薬剤の投与量データがバックエンドに存在しない可能性があります。",
      "renalAdjustment": "腎機能調整:",
      "originalDose": "元の投与量:",
      "min": "最小:",
      "max": "最大:",
      "recommended": "推奨: {{dose}} {{unit}}",
      "apply": "投与量を適用",
      "method": {
        "weightBased": "体重ベース",
        "bsaBased": "体表面積ベース",
        "flat": "固定投与量",
        "renalAdjusted": "腎機能調整"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "薬剤の処方",
    "submit": "処方",
    "navButton": "処方",
    "noActiveEncounter": "処方は有効な受診に関連付ける必要があります。処方する前に、この患者の受診を開始または入院させてください。",
    "fields": {
      "medication": "薬剤",
      "dose": "用量",
      "doseUnit": "単位",
      "route": "投与経路",
      "frequency": "頻度",
      "frequencyDescription": "頻度の説明",
      "duration": "投与期間",
      "durationUnit": "期間の単位",
      "totalDoses": "総投与回数",
      "isPrn": "頓用（PRN）",
      "prnIndication": "頓用の適応",
      "administrationInstructions": "投与に関する指示",
      "patientInstructions": "患者への説明",
      "quantityDispensed": "調剤数量",
      "refillsAuthorized": "追加調剤回数",
      "allowSubstitution": "後発品への変更を許可",
      "pharmacyNotes": "薬局への備考",
      "indication": "適応",
      "clinicalIndication": "臨床適応",
      "priority": "優先度"
    },
    "sections": {
      "drug": "薬剤",
      "dosing": "用量",
      "durationPrn": "投与期間・頓用（PRN）",
      "instructions": "投与指示",
      "dispensing": "調剤",
      "clinical": "臨床"
    },
    "doseUnitPlaceholder": "例: mg",
    "drugSearch": {
      "placeholder": "医薬品集を検索…",
      "noResults": "該当する医薬品がありません",
      "clear": "選択を解除",
      "catalogRequired": "処方する薬剤を医薬品集から選択してください",
      "catalogOnly": "各種安全チェックを実行できるよう、医薬品集の薬剤のみ処方できます。",
      "controlledBadge": "規制薬 — スケジュール {{schedule}}",
      "controlledTag": "規制薬",
      "highAlertBadge": "高警戒薬",
      "highAlertTag": "高警戒",
      "contraindications": "禁忌: {{text}}"
    },
    "route": {
      "oral": "経口（PO）",
      "iv": "静脈内（IV）",
      "subcutaneous": "皮下（SC）",
      "intramuscular": "筋肉内（IM）",
      "topical": "外用",
      "inhalation": "吸入",
      "rectal": "直腸（PR）",
      "ophthalmic": "点眼",
      "transdermal": "経皮"
    },
    "frequency": {
      "QD": "1日1回（QD）",
      "BID": "1日2回（BID）",
      "TID": "1日3回（TID）",
      "QID": "1日4回（QID）",
      "Q4H": "4時間ごと（Q4H）",
      "Q6H": "6時間ごと（Q6H）",
      "Q8H": "8時間ごと（Q8H）",
      "Q12H": "12時間ごと（Q12H）",
      "QHS": "就寝時（QHS）",
      "PRN": "頓用（PRN）",
      "STAT": "直ちに（STAT）"
    },
    "durationUnit": {
      "days": "日",
      "weeks": "週",
      "months": "か月",
      "doses": "回"
    },
    "priority": {
      "routine": "通常",
      "asap": "できるだけ早く",
      "stat": "緊急"
    },
    "validation": {
      "prnIndicationRequired": "頓用指示には頓用の適応が必要です"
    },
    "contextBar": {
      "ariaLabel": "処方時の参照情報",
      "allergies": {
        "label": "アレルギー",
        "none": "既知のアレルギーなし",
        "severe": "重度"
      },
      "weight": {
        "label": "体重",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "未記録"
      },
      "renal": {
        "label": "腎機能",
        "value": "eGFR {{egfr}} {{unit}}（{{source}}）",
        "unknown": "腎機能不明",
        "source": {
          "reported": "報告値",
          "computed": "計算値",
          "unknown": "不明"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "薬剤を処方しました",
      "error": "オーダーを登録できませんでした。もう一度お試しください。",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "安全性の注意事項付きで処方しました",
      "continue": "続行"
    },
    "safetyReview": {
      "title": "安全性レビューが必要です",
      "proceed": "上書きして処方",
      "cancel": "キャンセル",
      "reasonPrompt": "上書きの理由を選択…",
      "freeTextLabel": "追加の詳細",
      "freeTextPlaceholder": "臨床的背景を追加（任意）",
      "hardBlockNote": "このブロックは上書きできません。",
      "cannotOverride": "この処方は続行できません — 1つ以上のブロックは上書きできません。",
      "blockKind": {
        "cds_contraindication": "禁忌",
        "cds_unavailable": "安全性スクリーニング利用不可",
        "renal_contraindication": "腎機能禁忌",
        "dose_range": "推奨範囲外の用量",
        "pregnancy_contraindication": "妊娠リスク",
        "unknown": "追加の安全性ブロック"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "病歴を手動で確認済み",
        "NO_KNOWN_RISK_THIS_PATIENT": "この患者に既知のリスクなし",
        "URGENT_CLINICAL_NEED": "緊急の臨床的必要性",
        "OTHER": "その他（記載）",
        "BENEFIT_OUTWEIGHS_RISK": "利益がリスクを上回る",
        "DOSE_REDUCED_PER_PROTOCOL": "プロトコルに従い減量",
        "EGFR_NOT_REPRESENTATIVE": "eGFRが代表的でない",
        "SPECIALIST_ADVICE": "専門医の助言",
        "PATIENT_TOLERANT": "患者はこの用量に耐容",
        "SPECIALIST_PROTOCOL": "専門医プロトコルに従う",
        "TITRATING_TO_EFFECT": "効果に合わせて調整",
        "RANGE_NOT_APPLICABLE": "範囲は適用外",
        "STATUS_CONFIRMED_NEGATIVE": "妊娠していないことを確認済み",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "有益性が胎児リスクを上回る",
        "CONTRACEPTION_CONFIRMED": "有効な避妊を確認済み",
        "PREGNANCY_BEING_TERMINATED": "妊娠中絶の実施中"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
